import { ConfigProvider } from "antd";
import { Route, Routes } from "react-router";
import "./App.css";
import AuthLayout from "./layout/AuthLayout";
import UnAuthLayout from "./layout/UnAuthLayout";
import LoginPage from "./pages/LoginPage/LoginPage";
import Test from "./pages/Test";
import colors from "./style.module.scss";
import SingleSearchPage from "./pages/SingleSearchPage/SingleSearchPage";
import BulkSearchPage from "./pages/BulkSearchPage/BulkSearchPage";
import { Amplify } from "aws-amplify";
import APP_CONFIG from "./configs/environment";

Amplify.configure(APP_CONFIG.amplify_config);
function App() {
  return (
    <ConfigProvider
      theme={{
        token: { colorPrimary: colors.colorPrimary },
      }}>
      <Routes>
        <Route
          path=""
          element={<UnAuthLayout />}>
          <Route
            path=""
            element={<LoginPage />}
          />
        </Route>
        <Route
          path=""
          element={<AuthLayout />}>
          <Route
            path="single-search"
            element={<SingleSearchPage />}
          />
          <Route
            path="bulk-search"
            element={<BulkSearchPage />}
          />
        </Route>
      </Routes>
    </ConfigProvider>
  );
}

export default App;
